

const reducer = (state, action) => {
    switch(action.type){
        case 'CLEAR_CONTEXT_LOADING': {
            return {...state, contextLoading: false};
        }
        case 'OPEN_LOGIN': {
            return {...state, openLogin: true};
        }
        case 'CLOSE_LOGIN': {
            return {...state, openLogin: false};
        }

        case 'OPEN_OKCANCEL': {
            return {...state, openOkCancel: true};
        }
        case 'CLOSE_OKCANCEL': {
            return {...state, openOkCancel: false};
        }

        case 'OPEN_DRAWER': {
            return {...state, drawerState: true};
        }
        case 'CLOSE_DRAWER': {
            return {...state, drawerState: false};
        }

        case 'START_LOADING': {
            return {...state, loading: true};
        }
        case 'END_LOADING': {
            return {...state, loading: false};
        }
        
        case 'UPDATE_ALERT': {
            return {...state, alert: action.payload};
        }

        case 'UPDATE_OKCANCEL': {
            return {...state, okCancelDialog: action.payload};
        }

        case 'UPDATE_PROFILE': {
            //console.log('UPDATE_PROFILE:', action.payload);
            return {...state, profile: action.payload};
        }

        case 'OPEN_PASSWORD_MODAL': {
            return {...state, passwordModal: action.payload};
        }

        case 'UPDATE_USER': {
            localStorage.setItem('currentUser', JSON.stringify(action.payload));
            //console.log('action.payload', action.payload);
            return {...state, currentUser: action.payload};
        }

        case 'UPDATE_DAT_ALARMA': {
            //console.log('reducer.js - UPDATE_DAT_ALARMA:', action.payload);
            return {...state, datAlarma: action.payload};
        }
        
        case 'UPDATE_MARCAS': {
            //console.log('UPDATE_MARCAS:', action.payload.rows);
            return {...state, marcas: action.payload.rows};
        }

        case 'UPDATE_USERS': {
            //console.log('UPDATE_USERS:', action.payload.rows);    //A users los datos deben llegar en payload como {rows: valor}
            return {...state, users: action.payload.rows};
        }

        case 'UPDATE_PRODUCTOS': {
            //console.log('UPDATE_PRODUCTOS:', action.payload.rows);    //A productos los datos deben llegar en payload como {rows: valor}
            return {...state, productos: action.payload.rows};
        }

        case 'UPDATE_PROVEEDORES': {
            //console.log('UPDATE_PRODUCTOS:', action.payload.rows);    //A productos los datos deben llegar en payload como {rows: valor}
            return {...state, proveedores: action.payload.rows};
        }

        case 'UPDATE_CATEGORIAS': {
            //console.log('UPDATE_CATEGORIAS:', action.payload.rows);    //A categorias los datos deben llegar en payload como {rows: valor}
            return {...state, categorias: action.payload.rows};
        }

        //Alarma

        case 'UPDATE_CONFIG_RESP': {
            return {...state, resultConfig: action.payload};
        }

        default: {
            throw new Error('Acción seleccionada inexistente');
        }
        
    }


}

export default reducer;